import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import { CLEAR_MENU_CACHE, GLOBAL_SETTINGS, PUBLIC_PRIVACY_POLICY, PUBLIC_TERMS_CONDITIONS, UPDATE_GLOBAL_SETTING } from "helpers/url_helper"

export const getGlobalSettingByType = createAsyncThunk(
  GLOBAL_SETTINGS,
  async payload => {
    const response = await post(GLOBAL_SETTINGS, payload)
    return response
  }
)

export const getForceUpdateData = createAsyncThunk(
  GLOBAL_SETTINGS + GLOBAL_SETTINGS,
  async payload => {
    const response = await post(GLOBAL_SETTINGS, payload)
    return response
  }
)

export const updateGlobalSettingByType = createAsyncThunk(
  UPDATE_GLOBAL_SETTING,
  async payload => {
    const response = await put(UPDATE_GLOBAL_SETTING, payload)
    return response
  }
)

export const clearMenuCache = createAsyncThunk(CLEAR_MENU_CACHE, async () => {
  const response = await get(CLEAR_MENU_CACHE)
  return response
})

export const getPrivacyPolicy = createAsyncThunk(
  PUBLIC_PRIVACY_POLICY,
  async () => {
    const response = await get(PUBLIC_PRIVACY_POLICY)
    return response
  }
)

export const getTermsConditions = createAsyncThunk(
  PUBLIC_TERMS_CONDITIONS,
  async () => {
    const response = await get(PUBLIC_TERMS_CONDITIONS)
    return response
  }
)


